import React from 'react';

import { Container, Row, Col } from "reactstrap";

import { Construction } from "../../components";

class Portfolio extends React.Component {
  render() {
    return (
      <Container>
        <Construction />
      </Container>
    );
  }
}

export { Portfolio };

export default Portfolio;